export default "__VITE_ASSET__311ffc2f__"